import React from 'react';
import { CmsAsset } from '../../integrations/contentful/types';
import Spacing from '../common/Spacing';
import MediaGalleryThumbnail from './MediaThumbnail';

interface MediaThumbnailListProps {
  mediaList: readonly CmsAsset[];
  onMediaClick?: (media: CmsAsset) => void;
}

const MAX_VISIBLE_IMAGES = 5;
const MediaThumbnailList: React.FunctionComponent<MediaThumbnailListProps> = ({
  mediaList,
  onMediaClick
}) => {
  const mediaToShow = mediaList.slice(0, MAX_VISIBLE_IMAGES);
  const showMore = mediaList.length > MAX_VISIBLE_IMAGES;
  return (
    <div className="media-thumbnail-list">
      {mediaToShow.map((media, index) => {
        return (
          <div className="thumbnail-wrapper" key={index}>
            <Spacing right={2} top={2}>
              <MediaGalleryThumbnail
                media={media}
                onMediaClick={onMediaClick}
              />
            </Spacing>
          </div>
        );
      })}
      {showMore && (
        <div className="thumbnail-wrapper">
          <Spacing right={2} top={2}>
            <MediaGalleryThumbnail
              media={mediaList[MAX_VISIBLE_IMAGES]}
              onMediaClick={onMediaClick}
              showMoreOverlay
            />
          </Spacing>
        </div>
      )}
      {/*language=CSS*/}
      <style jsx>{`
        .media-thumbnail-list {
          display: flex;
        }
        .thumbnail-wrapper {
          width: 16%;
        }
        .show-more {
          position: relative;
        }
      `}</style>
    </div>
  );
};

export default MediaThumbnailList;
